import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Button/ButtonAnatomy.mdx";
import Usage from "../../Docs/Components/Button/ButtonUsage.mdx";
import DevGuidance from "../../Docs/Components/Button/ButtonDevGuidance.mdx";

import Examples from "../../Docs/Components/Button/ButtonExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Button"
            description="A button is used to indicate one or more available actions for the user."
            apiSources={["azure-devops-ui/Components/Button/Button.Props.d.ts", "azure-devops-ui/Components/Button/ExpandableButton.Props.d.ts", "azure-devops-ui/Components/Menu/MenuButton.Props.d.ts", "azure-devops-ui/Components/SplitButton/SplitButton.Props.d.ts", "azure-devops-ui/Components/ClipboardButton/ClipboardButton.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
            devGuidance={DevGuidance}
        />
    );
}
}
        
export default Page;